import { useRef } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
import { DialogModal } from './DialogModal';

interface DestructiveActionDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: React.ReactNode;
  confirmButtonText: string;
  cancelButtonText?: string;
  icon?: React.ReactNode;
}

export function DestructiveActionDialog(props: DestructiveActionDialogProps) {
  const {
    open,
    onClose,
    onConfirm,
    title,
    description,
    confirmButtonText,
    cancelButtonText = 'Cancel',
    icon = (
      <ExclamationTriangleIcon
        className="h-6 w-6 text-red-600"
        aria-hidden="true"
      />
    ),
  } = props;

  const cancelButtonRef = useRef(null);

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title={title}
      width="md"
      subTitle=""
      primaryButton={
        <div className="sm:flex sm:flex-row-reverse">
          <button
            type="button"
            className="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-red-600 sm:ml-3 sm:w-auto"
            onClick={onConfirm}
          >
            {confirmButtonText}
          </button>
          <button
            type="button"
            className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
            onClick={onClose}
            ref={cancelButtonRef}
          >
            {cancelButtonText}
          </button>
        </div>
      }
    >
      <div className="my-5 sm:flex sm:items-start">
        <div className="mx-auto hidden h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10 md:flex">
          {icon}
        </div>
        <div className="mt-3 sm:ml-4 sm:mt-0 sm:text-left">
          <p className="text-sm text-gray-700">{description}</p>
        </div>
      </div>
    </DialogModal>
  );
}
